import axiosInstance from "../../config/axios-config";
import {couponTimestamp} from "./coupon-lifecycle";

export const couponDate = value => value?.slice(0, 10) || "";
export const emptyCouponForm = () => ({discountValue: "", description: "", active: true, startDate: "", endDate: "", pharmacies: []});
export const couponForm = coupon => ({discountValue: coupon.discountValue,
    description: coupon.description ?? "", active: !!coupon.active,
    startDate: couponDate(coupon.startDate), endDate: couponDate(coupon.endDate),
    pharmacies: (coupon.pharmacies || []).map(pharmacy => ({...pharmacy})),
});

// The API uses LocalDateTime: preserve untouched times and never convert date inputs through UTC.
const timestamp = (date, original) => date === couponDate(original) ? original || null : date ? `${date}T00:00:00` : null;
export function couponPayload(form, existing) {
    return {
        discountValue: Number(form.discountValue), active: form.active ?? existing?.active ?? true,
        description: form.description ?? existing?.description ?? null,
        startDate: timestamp(form.startDate, existing?.startDate), endDate: timestamp(form.endDate, existing?.endDate),
        pharmacies: form.pharmacies.map(pharmacy => pharmacy.id),
    };
}

export function validCouponForm(form, existing) {
    const date = value => /^\d{4}-\d{2}-\d{2}$/.test(value) && !!couponTimestamp(`${value}T00:00:00`);
    const start = couponTimestamp(timestamp(form.startDate, existing?.startDate));
    const end = couponTimestamp(timestamp(form.endDate, existing?.endDate));
    // Date inputs can retain an original afternoon start but change the end to midnight on that day.
    return String(form.discountValue).trim() !== "" && Number.isFinite(Number(form.discountValue)) &&
        Number(form.discountValue) > 0 && Number(form.discountValue) <= 100 && date(form.startDate) && !!start &&
        (!form.endDate || (date(form.endDate) && !!end && end >= start));
}

// POST/PUT return pharmacy IDs; list/status responses return tenant objects. Keep one UI shape.
export function couponResponse(data, pharmacies = []) {
    return {...data, pharmacies: (data.pharmacies || []).map(pharmacy => typeof pharmacy === "string"
        ? pharmacies.find(candidate => candidate.id === pharmacy) || {id: pharmacy, tenantNameEn: pharmacy}
        : pharmacy)};
}

export async function saveCoupon(form, existing, options) {
    const payload = couponPayload(form, existing);
    const response = existing
        ? await axiosInstance.put(`/api/v1/coupons/${existing.couponId}`, payload, options)
        : await axiosInstance.post("/api/v1/coupons", payload, options);
    return couponResponse(existing ? response.data : response.data.data, form.pharmacies);
}

export const listCoupons = async options => {
    const {data} = await axiosInstance.get("/api/v1/coupons", options);
    if (!Array.isArray(data)) throw new Error("Invalid coupon list");
    return data.map(coupon => couponResponse(coupon));
};
export const deleteCoupon = (coupon, options) => axiosInstance.delete(`/api/v1/coupons/${coupon.couponId}`, options);
export const toggleCoupon = async (coupon, options) => {
    const {data} = await axiosInstance.patch(`/api/v1/coupons/${coupon.couponId}/status`, null, options);
    return couponResponse(data);
};
